// extracted by mini-css-extract-plugin
module.exports = {"main":"BBPicture_main__2tGG1","list":"BBPicture_list__2mgHN","firstItemBold":"BBPicture_firstItemBold__ChtMh","link":"BBPicture_link__2Oxkg"};